import { Role } from "../../types/role";

const SNSan: Role = {
  primary: [
    "Abschluss",
    "Ballannahme",
    "Dribbling",
    "Antizipation",
    "Nervenstaerke",
    "OhneBall",
    "Antritt",
  ],
  secondary: [
    "Passen",
    "Technik",
    "Einsatzfreude",
    "Entscheidungen",
    "Konzentration",
    "Ausdauer",
    "Balance",
    "Beweglichkeit",
    "Schnelligkeit",
  ],
  physis: "mittelfeld",
};

export const SNS = {
  SNSan,
};
